module.exports = __webpack_public_path__ + "static/Firewatch1-1ebdaac8ef954580c2f098bd6f52de41.webp";